<template lang='pug'>
  nav.bf-nav
    slot
      bf-wrapper.content.nav-container.container( @click.native='open.left = false' )
        left-nav( :class='{ open: open.left }' )
          nav-drawer( :user='user' :account='account' )
          
        bf-flex.logo-container
          router-link.logo.container( 
            v-if='$route.name != "verify-email" && $route.name != "new-profile" && $route.name != "onboarding"'
            :to='{ path: user ? account.merchant ? "/dashboard" : "/welcome" : "/"}' 
          )
            img(src='/ui/logo-full-white4a.svg')
          
          .logo.container( v-else )
            img(src='/ui/logo-full-white4a.svg')

          .links( v-if='$route.name == "verify-email"')
            sign-out.actionable.sign-out-link

          .links( v-if='user && $route.name != "verify-email" && $route.name != "new-profile" && $route.name != "onboarding"' )
            bf-flex.centered.link.actionable.user
              router-link( :to='{ name: user ? "welcome" : "sign-in"}' )
                img( src='/ui/home.svg' )
              
            bf-link.light.notifications.link(
              :to='{ name: account.merchant ? "biz-notifications" : "per-notifications" }'
              @click.native='open.left = false'
            )
              template(v-slot:icon)
                img( src='/ui/notification.svg')
              template(v-slot:text)
                .note-count.inline( v-show='notes.length' )
                  bf-flex.centered {{ notes.length }}

            router-link#schedule-link.schedule.link(
              :to='{ name: "schedule" }'
              @click='open.left = false'
            )
              img(src='/ui/calendar.svg')

            .link
              img.drawer-toggle.actionable(
                :src='account.avatar || "/no-image.png"'
                @click.stop='open.left = !open.left'
              )
</template>

<script>
  import { db, auth } from '@/main'
  import LeftNav from '@/components/left-nav'
  import VueCal from 'vue-cal'
  import NavDrawer from '@/components/nav-drawer'
  import SignOut from '@/components/auth/sign-out'

  export default {
    name: 'bf-nav.component',

    components: {
      LeftNav,
      NavDrawer,
      SignOut
    },

    props: {
      user: Object,
      account: [ Object, Array ],
      biz: [Object, Array ],
      notifications: Array
    },

    data() {
      return {
        open: { left: false, right: false },
        query: '',
        events: []
      }
    },

    computed: {
      notes() {
        if ( this.biz && this.account ) return this.notifications.filter( n => {
          switch( n.type ) {
            case 'msg' : return n.for == this.account.id
            case 'rsv' : return n.for == this.account.id || n.for == this.biz.id
            case 'cus' : return n.cus.business_id == this.biz.id
            case 'can' : return n.for == this.account.id
            case 'ref' : return n.for == this.account.id
            default: return false
          }
        })
        else return []
      }
    },

    watch: {
      notes( cr, pr ) {
        const note = cr.find( ( note, i ) => !pr.map( note => note.id ).includes( note.id ) )
        if ( note && note.type == 'rsv' ) new Audio('/kaching.mp3').play()
      },

      left(curr, prev) {
        this.open.left = false
      },

      query() {
        this.$emit('search', this.query)
      }
    },

    methods: {
      view() {

      },

      open_left() {
        this.$emit('open')
        this.open.left = true
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .bf-nav
    position fixed
    top 0
    left 0
    z-index 7
    padding 12px 0 4px 0
    transition all 320ms
    background var(--bg-nav)
    color var(--clr-nav)
    width 100vw

  .logo img
    height 30px
    @media(max-width: 480px)
      height 25px

  .links
    display flex
    align-items center
    margin-left auto
    .sign-out-link
      font-size 1.2em
    .link
      margin-left 32px
      img
        height 25px
        &.drawer-toggle
          border-radius 50%
          height 32px
          width 32px
          margin-top 1px
      &.user
        position relative
        bottom 1.5px
        img
          height 25px
          width 25px
          object-fit cover
        span
          margin-left 12px
          font-weight bold
          @media( max-width: 640px )
            display none

      &.notifications
        font-size 1.8em
        margin-bottom 2px
        position relative
        .note-count
          background red
          border-radius 50%
          position absolute
          height 1.25em
          width 1.25em
          left 15px
          top 0px
          font-size .55em
          z-index 1
          font-family monospace
</style>
